import * as getters from "./getters";
import * as actions from "./actions";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: {
    username: null,
    firstName: null,
    lastName: null,
    birthday: null,
    phoneNumber: null,
    subscribed: null,
    gender: null,
    avatarUrl: null,
    user: null,
  },
  mutations,
  actions,
  getters,
};
